export const filter_config = (event_options = [], mailbox_options) => ({
  title: 'Campaign filters',
  filters: [
    {
      label: 'Status',
      key: 'status',
      value: [
        { label: 'Draft', value: 'draft' },
        { label: 'Processed', value: 'processed' },
        { label: 'Processing', value: 'processing' },
        { label: 'Canceled', value: 'canceled' },
        { label: 'Paused', value: 'paused' }
      ],
      type: 'multichoice'
    },
    { label: 'Sender email', value: mailbox_options, key: 'sender_email', type: 'multichoice' },
    {
      label: 'Conversion event',
      value: event_options,
      key: 'conversion_event',
      type: 'multichoice'
    },
    { value: 'schedule.date', label: 'Date sent', key: 'schedule.date', type: 'range' }
  ]
});
